module.exports = __webpack_public_path__ + "img/solution-hil-system-pic.e6832312.png";